<app-header #header></app-header>
<div class="bg">
  <div class="container text-container">
    <h1>404</h1>
    <h1>Page not found</h1>
    <div class="description">
      Oops, it seems something went wrong or the page you are looking for doesn't exist anymore. These things happen, don't worry.
    </div>
  </div>
</div>
